import { useNavigate } from "react-router-dom";
import UserAccordionRow from "./Components/UserAccordianRow";



function InternalUsersPanel({ users = [], onCreateUser, onUserClick, expandedUserId }) {

    const navigate = useNavigate();
    function onBack() {
        navigate("/");
    }

    return (
        <div className="bg-white rounded-md border p-4">
            <div className="flex items-center justify-between mb-4">
                <button className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300" onClick={onBack}>&larr; Back</button>
                <h3 className="text-lg font-semibold flex-1 text-center">Manage Internal Users</h3>
                <button className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700" onClick={onCreateUser}>Create Internal User</button>
            </div>


            <div className="divide-y">
                {(!users || users.length === 0) && <div className="py-4 text-gray-500 text-center">No users found.</div>}
                {
                    users.map(user => (
                        <UserAccordionRow
                            key={user._id}
                            user={user}
                            expanded={expandedUserId === user._id}
                            onClick={() => onUserClick(user._id)}
                        />
                    ))
                }
            </div>
        </div>
    );
}

export default InternalUsersPanel;
